<script>
import {ref, toRef} from "vue";

export default {
  props: {
    addresses: {
      type: Array,
      default: null,
    },
  },
  setup(props, {slots}) {
    const addresses = toRef(props, "addresses");
    const visibleForm = ref(false);
    const currentlyEditedAddress = ref(null);

    const editAddress = id => {
      visibleForm.value = true;
      currentlyEditedAddress.value = addresses.value.find(el => el.id === id);
      scrollFormIntoView();
    };

    const cancelEdit = () => {
      visibleForm.value = false;
      currentlyEditedAddress.value = null;
      scrollFormIntoView();
    };

    const scrollFormIntoView = () => {
      // smaller than screen-lg
      if (window.matchMedia("(max-width: 1800px)").matches) {
        document
          .querySelector(".address-form")
          .scrollIntoView({behavior: "smooth"});
      }
    };
    const showAddForm = () => {
      visibleForm.value = true;
      currentlyEditedAddress.value = null;
      scrollFormIntoView();
    };

    return () =>
      slots.default({
        visibleForm: visibleForm.value,
        currentlyEditedAddress: currentlyEditedAddress.value || null,
        editAddress,
        cancelEdit,
        showAddForm,
      });
  },
};
</script>
